import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricChart from './HistoricChart';
import HolderEventsTable from './HolderEventsTable';

export default function TokenHolderEventsPage() {
  const { address, walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/tokens/${address}/holders/${walletAddress}/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    let variant: string;

    switch (data?.symbol) {
      case 'USDS':
        variant = 'usds';
        break;
      case 'sUSDS':
        variant = 'susds';
        break;
      case 'SKY':
        variant = 'sky';
        break;
      case 'DAI':
        variant = 'dai';
        break;
      case 'MKR':
        variant = 'mkr';
        break;
      default:
        variant = 'default';
        break;
    }

    return (
      <Page title={<Heading size="1">Wallet</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard address={walletAddress} />
          <KpiCard
            title="Balance"
            data={data}
            variant={variant}
            field="balance"
            options={{
              currency: tokensMapping(data.symbol)
            }}
          />
        </Flex>
        <HistoricChart symbol={data.symbol} />
        <HolderEventsTable
          address={address}
          walletAddress={walletAddress}
          symbol={data.symbol}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
